/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  MenuItem,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "@redux/actions";
import withStyles from "@material-ui/core/styles/withStyles";
import axios from "axios";
import BoardingCategoryTasksTable from "@components/table/BoardingCategoryTasksTable";
import { ERROR_MESSAGE } from "@utils/constants";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  centerText: {
    textAlign: "center",
    paddingTop: "10%",
  },
});
const EmployeeOnBoarding = ({ classes }) => {
  const dispatch = useDispatch();
  const [employeeData, setEmployeeData] = useState([]);
  const employees = useSelector((state) => state.employees.payload);
  const [employeeId, setEmployeeId] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadEmployeeData, setLoadEmployeeData] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleTaskStatusChange = (categoryIndex, taskIndex) => {
    const updatedEmployeeData = [...employeeData];
    updatedEmployeeData[categoryIndex].task_id[taskIndex].is_completed =
      !updatedEmployeeData[categoryIndex].task_id[taskIndex].is_completed;
    setEmployeeData(updatedEmployeeData);
  };

  async function fetchEmployeeOnBoardingData() {
    setLoading(true);
    setLoadEmployeeData(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_API_URL}/employees/get-employee-transition/${employeeId}?transitionType=onboard`
      );
      if (response.data) {
        // format data so that we can loop over tha data in categories and task table
        if (response.data.employee_data) {
          setIsUpdate(true);
          let reStructureData = {
            categories: [],
          };

          response.data.payload.onboard_info.forEach((singlecategory) => {
            if (singlecategory.category) {
              let newCategory = {
                _id: singlecategory.category._id,
                name: singlecategory.category.name,
                status: singlecategory.category.status,
              };
              let task_id = [];

              singlecategory.tasks.forEach((task) => {
                if (task.task_id) {
                  let taskObject = {
                    is_completed: task.is_completed,
                    name: task.task_id.name,
                    _id: task.task_id._id,
                    status: task.task_id.status,
                    comment: task.task_id.comment,
                  };
                  task_id = [...task_id, taskObject];
                }
              });
              newCategory = { ...newCategory, task_id };
              reStructureData.categories.push(newCategory);
            }
          });
          setEmployeeData(reStructureData.categories);
          setLoading(false);
        } else {
          let reStructureData = {
            categories: [],
          };
          response.data.payload.forEach((category) => {
            let generatedcategoryData = {
              name: category.name,
              _id: category._id,
              status: category.status,
            };
            let task_id = [];
            category.task_id.forEach((task) => {
              let generatedTask = {
                _id: task._id,
                comment: task.comment,
                name: task.name,
                status: task.status,
                is_completed: false,
              };
              task_id = [...task_id, generatedTask];
            });
            generatedcategoryData = { ...generatedcategoryData, task_id };
            reStructureData.categories.push(generatedcategoryData);
          });
          setEmployeeData(reStructureData.categories);
          setIsUpdate(false);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error.message || ERROR_MESSAGE + " while fetching employee onboarding"
      );
    }
  }

  function structuredData(originalData) {
    let formattedData = {
      transition_info: [],
    };

    originalData.forEach((category) => {
      let formattedCategory = {};
      let tasks = [];
      category.task_id.forEach((task) => {
        let formattedTask = {
          task_id: task._id,
          is_completed: task.is_completed,
        };
        tasks = [...tasks, formattedTask];
      });
      formattedCategory = {
        ...formattedCategory,
        category: category._id,
        tasks: tasks,
      };

      formattedData.transition_info.push(formattedCategory);
    });
    return formattedData;
  }

  async function createUpdateEmployeeOnBoarding() {
    setBtnLoading(true);
    const formattedEmployeeOnBoarding = structuredData(employeeData);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_NODE_API_URL}/employees/create-update-employee-transition/${employeeId}?transitionType=onboard`,
        formattedEmployeeOnBoarding
      );
      if (response.data) {
        toast.success("Employee On Boarding created successfully");
        setEmployeeId(null);
        setEmployeeData([]);
        setLoadEmployeeData(false);
        setBtnLoading(false);
      }
    } catch (error) {
      toast.error(ERROR_MESSAGE);
      setBtnLoading(false);
    }
  }

  useEffect(() => {
    if (isEmpty(employees)) {
      dispatch(fetchEmployees());
    }
  }, []);
  return (
    <Box paddingBottom={5}>
      <ToastContainer />
      <Box display="flex" justifyContent="center" alignItems="flex-end">
        <TextField
          label="Select Employee"
          variant="standard"
          className={classes.textField}
          value={employeeId}
          onChange={(e) => {
            setEmployeeId(e.target.value);
          }}
          select
        >
          {loading && !employees?.length ? (
            <MenuItem style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </MenuItem>
          ) : (
            employees?.map((employee, i) => {
              return (
                <MenuItem value={employee?._id} key={i}>
                  {employee.first_name} {employee.last_name}
                </MenuItem>
              );
            })
          )}
        </TextField>
        {employeeId ? (
          <Button
            variant="contained"
            color="primary"
            onClick={fetchEmployeeOnBoardingData}
          >
            Load Data
          </Button>
        ) : (
          ""
        )}
      </Box>
      {employeeId ? (
        <Box
          width="80%"
          margin="auto"
          marginTop={5}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          gap={3}
        >
          {loadEmployeeData && loading ? (
            <CircularProgress />
          ) : loadEmployeeData && !loading ? (
            <>
              <BoardingCategoryTasksTable
                categoryiesData={employeeData}
                onUpdateComplete={handleTaskStatusChange}
              />
              {btnLoading ? (
                <Button variant="contained" color="primary" disabled>
                  <CircularProgress color="primary" />
                </Button>
              ) : !btnLoading && isUpdate ? (
                <Button
                  variant="contained"
                  onClick={createUpdateEmployeeOnBoarding}
                  color="primary"
                >
                  Update
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={createUpdateEmployeeOnBoarding}
                  color="primary"
                >
                  Create
                </Button>
              )}
            </>
          ) : (
            ""
          )}
        </Box>
      ) : (
        <div className={classes.centerText}>
          <Typography variant="h7" style={{ whiteSpace: "pre-line" }}>
            Please Select Employee to see onBoarding
          </Typography>
        </div>
      )}
    </Box>
  );
};

export default withStyles(styles)(EmployeeOnBoarding);
